<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    okText="回复"
    @cancel="cancel"
    @ok="modal.childVisible = true"
    :maskClosable="false"
    :width="720"
  >
    <a-descriptions title="预约信息" :column="2">
      <a-descriptions-item label="预约记录编号">{{
        makeInfo.makeNo
      }}</a-descriptions-item>
      <a-descriptions-item label="预约时间">{{
        makeInfo.agreedTime
      }}</a-descriptions-item>
      <a-descriptions-item label="姓名"
        >{{ makeInfo.custName }}
        <a-tag
          class="render-tag"
          :color="makeInfo.isMan == 'MAN' ? '#108ee9' : 'red'"
          >{{ makeInfo.isMan == "MAN" ? "先生" : "女士" }}</a-tag
        >
      </a-descriptions-item>
      <a-descriptions-item label="联系方式">{{
        makeInfo.telPhone
      }}</a-descriptions-item>
      <a-descriptions-item label="备注" :span="2">{{
        makeInfo.intro
      }}</a-descriptions-item>
    </a-descriptions>
    <a-divider />
    <a-descriptions title="约看房源信息" :column="2">
      <a-descriptions-item label="房源名称" :span="2"
        >{{ makeInfo.houseName }}
        <a-tag class="render-tag" color="#87d068" v-if="makeInfo.rentSta == '2'"
          >已出租</a-tag
        >
      </a-descriptions-item>
      <a-descriptions-item label="楼号">{{
        makeInfo.buildingNo
      }}</a-descriptions-item>
      <a-descriptions-item label="单元号">{{
        makeInfo.unitNo
      }}</a-descriptions-item>
      <a-descriptions-item label="门牌号">{{
        makeInfo.houseNum
      }}</a-descriptions-item>
      <a-descriptions-item label="房号">{{
        makeInfo.roomNum
      }}</a-descriptions-item>
      <a-descriptions-item label="租金(元/月)"
        >￥{{ makeInfo.rent }}</a-descriptions-item
      >
    </a-descriptions>
    <a-divider />
    <h2>回复列表</h2>
    <a-list item-layout="horizontal" :data-source="recordList">
      <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
        <a-list-item-meta :description="item.feedback">
          <span slot="title" style="font-weight: bold;">{{
            item.backUserName ? item.backUserName : "暂无"
          }}</span>
        </a-list-item-meta>
        <div>{{ item.backTime }}</div>
      </a-list-item>
    </a-list>

    <a-modal
      v-model="modal.childVisible"
      title="回复"
      :width="500"
      @ok="save"
      :confirm-loading="confirmLoading"
    >
      <a-form-model
        ref="ruleForm"
        :model="formData"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 20 }"
      >
        <a-form-model-item label="内容" prop="feedback"
          ><a-input v-model="formData.feedback" type="textarea"
        /></a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-modal>
</template>

<script>
export default {
  name: "MakeInfo",
  data() {
    return {
      confirmLoading: false,
      //弹出框参数
      modal: {
        visible: false,
        title: "查看",
        childVisible: false
      },
      makeInfo: {},
      recordList: [],
      formData: {
        makeNo: "",
        feedback: ""
      },
      rules: {
        feedback: [
          {
            required: true,
            message: "请输入回复内容",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    showModal(data) {
      this.modal.visible = true;
      this.makeInfo = data;
      this.formData.makeNo = this.makeInfo.makeNo;
      this.queryRecord();
    },
    cancel() {
      this.recordList = [];
      this.formData = {};
      this.confirmLoading = false;
      this.$refs.ruleForm.resetFields();
      this.modal.visible = false;
      this.modal.childVisible = false;
    },
    queryRecord() {
      this.$http.roomBksApi
        .listHouseMakeReplyByMakeNo({ makeNo: this.makeInfo.makeNo })
        .then(res => {
          if (res.result == 0) {
            this.recordList = res.resultObject;
          }
        });
    },
    save() {
      // saveHouseMakeReply
      this.confirmLoading = true;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          this.$http.roomBksApi.saveHouseMakeReply(param).then(res => {
            this.confirmLoading = false;
            if (res.result == 0) {
              this.$message.success(res.msg);
              this.cancel();
              this.$emit("success");
            }
          });
        } else {
          this.confirmLoading = false;
        }
      });
    }
  }
};
</script>

<style></style>
